import { ITEM_TEXT_DELIMITER_TYPE } from './Constants';

const _getItemsByMultipleDelimiter = items => {
  const itemsByMultipleDelimiter = items.reduce((acc, item) => {
    const splittedItemByMultipleDelimiter = item.split(ITEM_TEXT_DELIMITER_TYPE.MULTIPLE_ITEM);
    const isMultipleItem = splittedItemByMultipleDelimiter.length > 1;

    if (isMultipleItem) {
      const pushedCount = splittedItemByMultipleDelimiter[1];

      // eslint-disable-next-line no-plusplus
      for (let i = 1; i <= pushedCount; i++) {
        acc.push(splittedItemByMultipleDelimiter[0]);
      }
    } else {
      acc.push(item);
    }

    return acc;
  }, []);

  return itemsByMultipleDelimiter;
};

const _getItemNameAndCountList = items => {
  const itemNameAndCountList = items.reduce((acc, item) => {
    const existedItemIndex = acc.findIndex(({ name }) => name === item);

    if (existedItemIndex > -1) {
      acc[existedItemIndex].count += 1;
    } else {
      acc.push({
        name: item,
        count: 1,
      });
    }

    return acc;
  }, []);

  return itemNameAndCountList;
};

const _getItemsAndHiddenItems = itemList => {
  const items = [];
  const hiddenItems = [];

  itemList.forEach(item => {
    if (item.name.startsWith(ITEM_TEXT_DELIMITER_TYPE.HIDDEN_ITEM)) {
      hiddenItems.push(item);
    } else {
      items.push(item);
    }
  });

  return { items, hiddenItems };
};

const getParamsToItemPropertyReducer = values => {
  const splittedValue = values
    .split(ITEM_TEXT_DELIMITER_TYPE.SPLIT)
    .filter(value => value)
    .map(value => value.trim());

  const itemsByMultipleDelimiter = _getItemsByMultipleDelimiter(splittedValue);
  const itemNameAndCountList = _getItemNameAndCountList(itemsByMultipleDelimiter);

  const { items, hiddenItems } = _getItemsAndHiddenItems(itemNameAndCountList);
  return { items, hiddenItems };
};

export { getParamsToItemPropertyReducer };
